var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMqp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167 85.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mqp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mqp"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.61,50.25a4,4,0,0,0,2.66-.94c.39-.48.58-1.6.58-3.36V32.42a3.4,3.4,0,0,0-.57-2.35,4.43,4.43,0,0,0-2.58-.64v-.62h6.57l7.65,16.61,7.47-16.61H124v.62a4,4,0,0,0-2.4.68,3.49,3.49,0,0,0-.53,2.31V47.24a3.47,3.47,0,0,0,.53,2.33,4.34,4.34,0,0,0,2.4.68v.62h-9.33v-.62a4,4,0,0,0,2.51-.73,4.46,4.46,0,0,0,.5-2.67v-15l-8.54,19h-.45l-8.39-18.2V46c0,1.83.26,3,.8,3.57a4.08,4.08,0,0,0,2.32.73v.62H95.61Z",
    fill: "#007650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.22,31.29a11.18,11.18,0,0,1,15.09,0,11.26,11.26,0,0,1,3.4,8.6,11.88,11.88,0,0,1-2.16,7.21,10.32,10.32,0,0,1-6.63,4,11.29,11.29,0,0,0,4.87,4.12,16.44,16.44,0,0,0,4.35,1v.62h-1.37a23.62,23.62,0,0,1-4.79-.44,14.84,14.84,0,0,1-3.8-1.34A11.43,11.43,0,0,1,135,52.59,17.31,17.31,0,0,0,133.4,51l-.42-.2a13.43,13.43,0,0,1-4.29-2.93,11.27,11.27,0,0,1-2.82-8A11.33,11.33,0,0,1,129.22,31.29Zm2.5,16.33a6.4,6.4,0,0,0,10.12.06q2.1-2.45,2.1-7.83c0-3.64-.71-6.26-2.12-7.88a6.46,6.46,0,0,0-5-2.43,6.36,6.36,0,0,0-5.08,2.52q-2.07,2.5-2.07,7.79T131.72,47.62Z",
    fill: "#007650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.49,50.25a3.63,3.63,0,0,0,2.37-.76,4.62,4.62,0,0,0,.48-2.63V32.42a3.48,3.48,0,0,0-.53-2.29,3.84,3.84,0,0,0-2.32-.7v-.62h8.79a10.79,10.79,0,0,1,6.47,1.65A5.09,5.09,0,0,1,167,34.78a5.36,5.36,0,0,1-2.49,4.94,11.72,11.72,0,0,1-6.23,1.53l-1.38,0-1.24,0v6q0,1.88.57,2.37a5.16,5.16,0,0,0,2.58.63v.62h-9.32Zm11.24-19.58a8.81,8.81,0,0,0-3.58-.62,2.41,2.41,0,0,0-1.26.2c-.16.14-.23.44-.23.91v8.69l1.17.09a4.78,4.78,0,0,0,.53,0,8.34,8.34,0,0,0,3.62-.65q2.39-1.19,2.39-4.44A4.18,4.18,0,0,0,160.73,30.67Z",
    fill: "#007650"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.43,77V59.55a23.94,23.94,0,0,0,1-32.86L85.11,51.3,59.43,77Z",
    fill: "#fbbe00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13,59.46H25.6a23.92,23.92,0,0,0,32.68,1.16L33.81,85.15,8.13,59.46Z",
    fill: "#006e49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.68,8.17V25.62A23.93,23.93,0,0,0,24.5,58.28L0,33.85,25.68,8.17Z",
    fill: "#fbbe00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,25.68H59.49a23.93,23.93,0,0,0-32.4-1.35L51.35,0,77,25.68Z",
    fill: "#006e49"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.56 54.66 59.42 54.66 52.82 27.03 45.53 27.03 44.03 31.94 49.56 54.66 49.56 54.66",
    fill: "#006e49"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.24 54.66 47.1 54.66 40.49 27.03 33.21 27.03 31.71 31.94 37.24 54.66 37.24 54.66",
    fill: "#006e49"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.91 54.66 34.78 54.66 30.25 36.9 24.91 54.66 24.91 54.66",
    fill: "#006e49"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMqp);
export default __webpack_public_path__ + "static/media/Logo-MQP.c5817d79809d48d9631879de00236360.svg";
export { ForwardRef as ReactComponent };